// @react/hooks/useSubscriptionEntitlement.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { subscriptionEntitlementStore } from '@core/stores';

/**
 * React hook for Entitlement operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useSubscriptionEntitlement } from '@react/hooks';
 *
 * const EntitlementList = observer(() => {
 *   const store = useSubscriptionEntitlement();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useSubscriptionEntitlement() {
  return subscriptionEntitlementStore;
}
